import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api/authApi";
import type { LoginRequest } from "../types/auth";
import { useLanguage } from "../i18n/LanguageContext";

export function LoginPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const request: LoginRequest = { username, password };
      const response = await login(request);

      localStorage.setItem("token", response.token);
      navigate("/diaries");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <h1>Valesco</h1>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="form-error" style={{ marginBottom: 12 }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">{t.auth.username}</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t.auth.password}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button className="primary-button" type="submit" disabled={loading}>
            {loading ? t.auth.loggingIn : t.auth.login}
          </button>
        </form>

        <p className="form-footer">
          {t.auth.noAccount}{" "}
          <button
            type="button"
            className="link-button"
            onClick={() => navigate("/register")}
          >
            {t.auth.registerLink}
          </button>
        </p>
      </section>
    </main>
  );
}
